<template>
    <div :class="className">
        <p v-if="priceData && priceData.original_price_inkl_vat > priceData.price" class="headline light--text text--darken-4 ma-0">
            <del>{{priceData.original_price_inkl_vat | currency}}</del>
        </p>
        {{price | currency}}
    </div>
</template>

<script>
    const name = 'ProductPrice';

    export default {
        name: name,
        props: {
            price: {},
            priceData: {},
            className: {
                default: 'display-1',
            }
        },
    };
</script>